import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export function ScanFlash() {
  const [state, setState] = useState(null);
  useEffect(() => {
    let t;
    const on = (e) => {
      setState({ ...e.detail, id: Date.now() });
      clearTimeout(t);
      t = setTimeout(() => setState(null), 1600);
    };
    window.addEventListener("sk-scan", on);
    return () => { window.removeEventListener("sk-scan", on); clearTimeout(t); };
  }, []);
  if (!state) return null;
  const ok = state.ok;
  return (
    <>
      <div key={`f${state.id}`} className={`pointer-events-none fixed inset-0 z-[90] sk-flash ${ok ? "shadow-[inset_0_0_0_6px_#10b981]" : "shadow-[inset_0_0_0_6px_#e11d48]"}`} />
      <div key={`p${state.id}`} data-testid="scan-feedback" data-status={ok ? "ok" : "error"}
        className={`pointer-events-none fixed left-1/2 top-4 z-[95] flex -translate-x-1/2 items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white shadow-lg sk-rise ${ok ? "bg-emerald-600" : "bg-rose-600"}`}>
        {ok ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}
        <span className="font-mono">{state.label || (ok ? "Scan OK" : "Échec du scan")}</span>
      </div>
    </>
  );
}
